import { render, staticRenderFns } from "./YaprakYakinPage.vue?vue&type=template&id=446ccacc&scoped=true&"
import script from "./YaprakYakinPage.vue?vue&type=script&lang=js&"
export * from "./YaprakYakinPage.vue?vue&type=script&lang=js&"
import style0 from "./YaprakYakinPage.vue?vue&type=style&index=0&id=446ccacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ccacc",
  null
  
)

export default component.exports